import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';



const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {
  const [formData, setFormData] = useState({
    vendor: '',
    mobile: '',
    request: '',
    response: '',
    date: '',
  });
  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    let formErrors = {};

    if (formData.vendor === '') {
      formErrors.vendor = 'Vendor cannot be empty';
    }
    if (formData.mobile === '') {
      formErrors.mobile = 'Mobile cannot be empty';
    }
    if (formData.request === '') {
      formErrors.request = 'Request cannot be empty';
    }
    if (formData.response === '') {
      formErrors.response = 'Response cannot be empty';
    }
    if (formData.date === '') {
      formErrors.date = 'Date cannot be empty';
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // No errors
  };

  const token = authServices.getToken();
  const handleSubmit = async (e) => {
    // e.preventDefault();

    if (!validateForm()) {
      return; // Stop submission if there are validation errors
    }

    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/api_logs/add', formData, {
      
              headers: {
                'access_token': token,
              },
      
            });

      if (response.data.Status === "SUCCESS") {

        setFormData({
          vendor: '',
          mobile: '',
          request: '',
          response: '',
          date: '',
        });

      }
      else {
        console.log(response.data.message)
      }

    }
    catch (error) {
      console.error('catch Error :-', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
      toggle();
      // window.location.reload();
    }

  };

  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add api_Logs</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >
                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block" >
                        <label htmlFor="vendor" className="label-custom">Vendor</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.vendor ? 'input-error' : ''}`}
                          id="vendor"
                          name="vendor"
                          value={formData.vendor}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="mobile" className="label-custom">Mobile</label>
                        <input
                          type="mobile"
                          className={`input-custom ${errors.mobile ? 'input-error' : ''}`}
                          id="mobile"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                        // placeholder="Enter Billing Name"
                        />
                      </div>
                    </div>

                    <div className='row w-100'>
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="request" className="label-custom">Request</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.request ? 'input-error' : ''}`}
                          id="request"
                          name="request"
                          value={formData.request}
                          onChange={handleChange}
                        // placeholder="Enter Amount"
                        />
                      </div>
                      <div className="spacing w-50 d-inline-block">
                        <label htmlFor="response" className="label-custom">Response</label>
                        <input
                          type="text"
                          className={`input-custom ${errors.response ? 'input-error' : ''}`}
                          id="response"
                          name="response"
                          value={formData.response}
                          onChange={handleChange}
                        // placeholder="Enter Amount"
                        />
                      </div>
                    </div>

                    <div className="spacing " style={{ width: '97%' }}>
                      <label htmlFor="date" className="label-custom">Date</label>
                      <input
                        type="date"
                        className={`date-input ${errors.date ? 'input-error' : ''}`}
                        id="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                      // placeholder="Enter Amount"
                      />
                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>
                  
                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
